var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2-github, .cls-3-github {\n        fill: #221e1b;\n      }\n\n      .cls-2-github {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stickers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "github"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2-github",
    d: "M623.28,619.37c-34.67-3.07-67.57,19.29-73.48,49.94-4.73,24.52,9.24,46.92,32.77,56.46,3,.8,4.52-.82,4.81-2.29s1-5.7,1.9-10.34c-18.11,1.81-19.88-8.42-19.88-8.42C567.78,698.06,564,696,564,696c-5-3.94,1.08-3.33,1.08-3.33a11.53,11.53,0,0,1,8.52,6.57c4,9,13.52,7.33,17.38,6.23a13.19,13.19,0,0,1,5.42-7.07c-13.67-2.63-27.42-8.69-23.31-30a23,23,0,0,1,9.34-14.32c-.38-1.46-1.44-7.29,3.44-14.64,0,0,5.56-1,16.17,7.22a70.16,70.16,0,0,1,16.07-.48,65.11,65.11,0,0,1,15.37,3.27c13.37-6.12,18.34-4.17,18.34-4.17A18.42,18.42,0,0,1,649.6,660a18.62,18.62,0,0,1,3.58,15.47c-4.11,21.32-19.7,24.71-33.94,24.85,1.92,1.92,3.27,5.48,2.27,10.65-1.43,7.43-2.66,13.4-3,15.23-.28,1.48.51,3.31,3.8,3,26.35-5.14,48.32-24.34,53.05-48.86C681.26,649.77,658,622.44,623.28,619.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M568.91,695.6a.9.9,0,0,1-1.11.07c-.42-.22-.6-.62-.4-.88a.89.89,0,0,1,1.11-.08c.42.23.61.63.4.89Zm-.67-.57"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M571,698.33a1,1,0,0,1-1.23-.37.77.77,0,0,1,0-1.17,1,1,0,0,1,1.23.37c.34.43.32,1,0,1.17Zm-.49-.62"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M572.83,701.75a1.1,1.1,0,0,1-1.31-.6.93.93,0,0,1,.26-1.33,1.09,1.09,0,0,1,1.31.59.94.94,0,0,1-.26,1.34Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M575.62,705.14a1.25,1.25,0,0,1-1.57-.36,1,1,0,0,1-.08-1.45,1.27,1.27,0,0,1,1.58.36c.46.49.5,1.15.07,1.45Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M580,707.34a1.39,1.39,0,0,1-1.66.31c-.67-.25-1-.8-.81-1.23a1.39,1.39,0,0,1,1.66-.3c.67.25,1,.79.81,1.22Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M585,708.13c-.07.46-.75.79-1.5.73s-1.29-.48-1.21-.93.75-.78,1.51-.73,1.29.48,1.2.93Zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3-github",
    d: "M590,707.84c0,.45-.61.86-1.37.92s-1.37-.28-1.38-.73.61-.88,1.36-.94,1.38.28,1.39.75Zm0,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.35e9a51d34386de4a766a68b9f8bd7f1.svg";
export { ForwardRef as ReactComponent };